import React from 'react';
import { COLORS, DARK_THEME } from '../../constants/colors';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { LandmarkIcon, TrainIcon, MusicIcon, MonitorIcon } from '../Icons';

const News = () => {
  const { isDarkMode } = useTheme();
  const { language } = useLanguage();

  const news = [
    {
      date: language === 'tr' ? '15 Aralık 2024' : 'Dec 15, 2024',
      category: language === 'tr' ? 'Zirve' : 'Summit',
      title: language === 'tr'
        ? "TDT Liderleri Yıllık Zirve İçin Bişkek'te Bir Araya Geldi"
        : 'OTS Leaders Meet in Bishkek for Annual Summit',
      excerpt: language === 'tr'
        ? 'Devlet başkanları, ekonomik entegrasyon ve kültürel iş birliği girişimlerini ele aldı.'
        : 'Heads of state discuss economic integration and cultural cooperation initiatives.',
      Icon: LandmarkIcon,
    },
    {
      date: language === 'tr' ? '10 Aralık 2024' : 'Dec 10, 2024',
      category: language === 'tr' ? 'Ekonomi' : 'Economy',
      title: language === 'tr'
        ? 'Yeni Ticaret Koridoru Anlaşması İmzalandı'
        : 'New Trade Corridor Agreement Signed',
      excerpt: language === 'tr'
        ? 'Üye devletler, Hazar Geçişli güzergâh için basitleştirilmiş gümrük prosedürleri üzerinde anlaştı.'
        : 'Member states agree on simplified customs procedures for the Trans-Caspian route.',
      Icon: TrainIcon,
    },
    {
      date: language === 'tr' ? '5 Aralık 2024' : 'Dec 5, 2024',
      category: language === 'tr' ? 'Kültür' : 'Culture',
      title: language === 'tr'
        ? '2025 Türk Kültür Festivali Duyuruldu'
        : 'Turkic Cultural Festival Announced for 2025',
      excerpt: language === 'tr'
        ? 'Ortak mirası kutlayacak olan yıllık festivale Semerkant ev sahipliği yapacak.'
        : 'Annual festival to be hosted in Samarkand, celebrating shared heritage.',
      Icon: MusicIcon,
    },
    {
      date: language === 'tr' ? '28 Kasım 2024' : 'Nov 28, 2024',
      category: language === 'tr' ? 'Teknoloji' : 'Technology',
      title: language === 'tr'
        ? 'Dijital İpek Yolu Girişimi Başlatıldı'
        : 'Digital Silk Road Initiative Launched',
      excerpt: language === 'tr'
        ? 'Teknoloji iş birliği programı, Türk devletlerindeki girişimleri birbirine bağlamayı amaçlıyor.'
        : 'Tech cooperation program aims to connect startups across Turkic nations.',
      Icon: MonitorIcon,
    },
  ];

  return (
    <section id="news" style={{
      ...styles.section,
      backgroundColor: isDarkMode ? DARK_THEME.background : COLORS.white,
    }}>
      <div style={styles.container}>
        <div style={styles.header}>
          <span style={{
            ...styles.badge,
            backgroundColor: isDarkMode ? `${DARK_THEME.accent}20` : `${COLORS.accent}15`,
            color: isDarkMode ? DARK_THEME.accent : COLORS.accent,
          }}>{language === 'tr' ? 'Güncel Gelişmeler' : 'Latest Updates'}</span>
          <h2 style={{...styles.title, color: isDarkMode ? DARK_THEME.textPrimary : COLORS.dark}}>
            {language === 'tr' ? 'Haberler ve Etkinlikler' : 'News & Events'}
          </h2>
        </div>

        <div style={styles.grid}>
          {news.map((item, index) => (
            <article key={index} style={{
              ...styles.card,
              backgroundColor: isDarkMode ? DARK_THEME.surface : COLORS.light,
            }}>
              <div style={{
                ...styles.imageWrapper,
                background: isDarkMode 
                  ? `linear-gradient(135deg, ${DARK_THEME.primary} 0%, ${DARK_THEME.backgroundTertiary} 100%)`
                  : COLORS.silkRoadGradient,
              }}>
                <item.Icon size={52} color="rgba(255,255,255,0.92)" strokeWidth={1.6} />
              </div>
              <div style={styles.content}>
                <div style={styles.meta}>
                  <span style={{
                    ...styles.category,
                    backgroundColor: isDarkMode ? `${DARK_THEME.primary}30` : `${COLORS.primary}20`,
                    color: isDarkMode ? DARK_THEME.primary : COLORS.primary,
                  }}>{item.category}</span>
                  <span style={{...styles.date, color: isDarkMode ? DARK_THEME.textMuted : '#888'}}>
                    {item.date}
                  </span>
                </div>
                <h3 style={{...styles.newsTitle, color: isDarkMode ? DARK_THEME.textPrimary : COLORS.dark}}>
                  {item.title}
                </h3>
                <p style={{...styles.excerpt, color: isDarkMode ? DARK_THEME.textSecondary : '#666'}}>
                  {item.excerpt}
                </p>
                <button style={{...styles.readMore, color: isDarkMode ? DARK_THEME.primary : COLORS.primary}}>
                  {language === 'tr' ? 'Devamını Oku →' : 'Read More →'}
                </button>
              </div>
            </article>
          ))}
        </div>

        <div style={{
          ...styles.newsletter,
          backgroundColor: isDarkMode ? DARK_THEME.surface : COLORS.dark,
        }}>
          <div style={styles.newsletterContent}>
            <h3 style={styles.newsletterTitle}>{language === 'tr' ? 'Haberdar Olun' : 'Stay Informed'}</h3>
            <p style={styles.newsletterText}>
              {language === 'tr'
                ? 'Türk dünyasından en güncel haber ve gelişmeleri almak için abone olun.'
                : 'Subscribe to receive the latest news and updates from the Turkic world.'}
            </p>
          </div>
          <div style={styles.newsletterForm}>
            <input
              type="email"
              placeholder={language === 'tr' ? 'E-posta adresinizi girin' : 'Enter your email'}
              style={styles.emailInput}
            />
            <button style={{
              ...styles.subscribeButton,
              backgroundColor: isDarkMode ? DARK_THEME.primary : COLORS.secondary,
              color: isDarkMode ? COLORS.dark : COLORS.dark,
            }}>{language === 'tr' ? 'Abone Ol' : 'Subscribe'}</button>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '100px 20px',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
  },
  badge: {
    display: 'inline-block',
    padding: '8px 20px',
    borderRadius: '50px',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '20px',
  },
  title: {
    fontSize: 'clamp(32px, 5vw, 48px)',
    fontWeight: '700',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '25px',
    marginBottom: '60px',
  },
  card: {
    borderRadius: '16px',
    overflow: 'hidden',
    transition: 'transform 0.3s ease',
    cursor: 'pointer',
  },
  imageWrapper: {
    height: '160px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    padding: '25px',
  },
  meta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  category: {
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
  },
  date: {
    fontSize: '12px',
  },
  newsTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '10px',
    lineHeight: '1.4',
  },
  excerpt: {
    fontSize: '14px',
    lineHeight: '1.6',
    marginBottom: '15px',
  },
  readMore: {
    background: 'none',
    border: 'none',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    padding: 0,
  },
  newsletter: {
    borderRadius: '20px',
    padding: '50px 40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '30px',
  },
  newsletterContent: {
    flex: '1 1 300px',
  },
  newsletterTitle: {
    color: COLORS.white,
    fontSize: '24px',
    marginBottom: '10px',
    fontWeight: '700',
  },
  newsletterText: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: '15px',
  },
  newsletterForm: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  emailInput: {
    padding: '15px 20px',
    borderRadius: '50px',
    border: 'none',
    fontSize: '15px',
    width: '280px',
    outline: 'none',
  },
  subscribeButton: {
    padding: '15px 30px',
    borderRadius: '50px',
    border: 'none',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default News;
